import { MarketsContainer } from '@/features/sparklend/markets/MarketsContainer'

export function Markets() {
  return <MarketsContainer />
}
